export const years = Array.from(
    { length: new Date().getFullYear() - 2025 + 1 },
    (_, index) => 2025 + index
);

export const semesters = [
    { name: 'Enero a Junio', value: 1 },
    { name: 'Julio a Diciembre', value: 2 },
];
